import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ss_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Expired/invalid session (e.g. 12h JWT expiry) -> clean return to login.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const url = error.config?.url || "";
    const isAuthCall = url.includes("/auth/");
    if (error.response?.status === 401 && !isAuthCall) {
      localStorage.removeItem("ss_token");
      localStorage.removeItem("ss_auth");
      if (!window.location.pathname.startsWith("/setup/")) {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (fileId) => `${API}/files/${fileId}`;

// Brand logos
export const LOGOS = {
  blueIcon: "https://customer-assets.emergentagent.com/job_safety-portal-27/artifacts/ccz7zskr_blue%20icon.svg",
  blueWordmark: "https://customer-assets.emergentagent.com/job_safety-portal-27/artifacts/35e9iz0s_blue%20wordmark.svg",
  whiteIcon: "https://customer-assets.emergentagent.com/job_safety-portal-27/artifacts/3rbmuw42_white%20icon.svg",
  whiteWordmark: "https://customer-assets.emergentagent.com/job_safety-portal-27/artifacts/vg4adc96_white%20wordmark.svg",
};

export const CATEGORIES = ["Governance", "Procedure", "SWP", "Handbook", "Induction", "Tool", "Resource", "Client uploads"];
export const CATEGORY_LABELS = {
  Governance: "Governance", Procedure: "Procedures", SWP: "Safe Work Procedures",
  Handbook: "Handbooks", Induction: "Inductions", Tool: "Tools", Resource: "Resources",
  "Client uploads": "Client Uploads",
};
export const MANAGER_CATEGORIES = ["Governance", "Procedure", "SWP", "Handbook", "Induction"];

// Grouped library order + display labels (Manager & Review portals)
export const CATEGORY_GROUPS = [
  { cat: "Governance", label: "Governance" },
  { cat: "Procedure", label: "Procedures" },
  { cat: "SWP", label: "Safe Work Procedures" },
  { cat: "Induction", label: "Inductions" },
  { cat: "Handbook", label: "Handbooks" },
  { cat: "Tool", label: "Tools" },
  { cat: "Resource", label: "Resources" },
  { cat: "Client uploads", label: "Client Uploads" },
];
export const STATUSES = ["Not Started", "In Progress", "In Review", "Amending", "In Consultation", "Pending Approval", "Approved"];

export const DECISION_SECTIONS = [
  { key: "the_decision", label: "The Decision" },
  { key: "why_this_matters", label: "Why This Matters" },
  { key: "legal_position", label: "The Legal Position" },
  { key: "on_the_ground", label: "What This Looks Like On The Ground" },
];

export const STATUS_COLORS = {
  "Not Started": "#6B7280",
  "In Progress": "#3B82F6",
  "In Review": "#F59E0B",
  "Amending": "#8B5CF6",
  "In Consultation": "#14B8A6",
  "Pending Approval": "#F97316",
  "Approved": "#10B981",
};
